import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "@/lib/useQuery/queryKeys";
import { saveSurveyAsTemplate } from ".";

export function useSaveSurveyAsTemplate() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: queryKeys.survey_bank._def,
        mutationFn: saveSurveyAsTemplate,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.survey_bank._def, exact: false });
        }
    })
}